import { BUTTON_SUBMISSION, MY_ACCOUNT_SETTINGS, STASH, ERROR } from '../constants';

const trackEvent = (settings, { category = BUTTON_SUBMISSION, eventMode } = {}) => {
  const DDOEvent = {
    category: {
      primaryCategory: category
    },
    eventInfo: {
      eventName: MY_ACCOUNT_SETTINGS
    },
    ...(eventMode && { eventMode }),
    myAccount: {
      settings
    }
  };

  digitalData.event = digitalData.event || [];
  digitalData.event.push(DDOEvent);
};

// profile-page-analytics.ts / analytics.ts events for the Profile page
export const profileEvents = () => {
  // setEditEvent(area, field) (src/utils/analytics.ts)
  // Shared by personal-info.tsx, company-details.tsx, and tax-exempt.tsx edit/link clicks.
  window.LIFE_CYCLE_EVENT_BUS.on('profile.edit-event', ({ output }) => {
    const area = output?.area || '';
    const field = output?.field || '';
    trackEvent(`${area}: ${field}`);
  });

  // setProfileAccountClosureLinksAnalytics(link) (src/utils/profile-page-analytics.ts)
  window.LIFE_CYCLE_EVENT_BUS.on('profile.account-closure-link', ({ output }) => {
    const link = output?.link || '';
    trackEvent(`profile: ${link}`, { category: STASH, eventMode: STASH });
  });

  // pushErrorEvent(pageSection, displayType, errCode, errMessage) (src/utils/analytics.ts)
  // Shared by personal-info.tsx (API/save/zip-code errors), company-details.tsx
  // (save/zip-code errors), and the convert-to-pro company-details-modal-content.tsx.
  window.LIFE_CYCLE_EVENT_BUS.on('profile.error-event', ({ output }) => {
    const pageSection = output?.pageSection || '';
    const displayType = output?.displayType || 'inline';
    const code = output?.code || '';
    const message = output?.message || '';

    const DDOEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type: 'error',
          displayType,
          pageSection,
          code,
          message
        }]
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
